import { render } from "./AsideMenu.vue?vue&type=template&id=6b5730c2"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/project-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__